import { createTheme } from '@mui/material/styles';
import { makeStyles as muiMakeStyles } from 'utils/styles/mui';




// Create a default theme for makeStyles
const defaultTheme = createTheme();

// Wrapper around makeStyles to provide default theme
export const makeStyles = (styles) => {
  return muiMakeStyles(styles, { defaultTheme });
};

export default makeStyles;